mobileSize = 1000;

function countdown() {
    if ($('body').hasClass('saffireMobileSize')) {
        $('.countdown-main').insertAfter('#swiperWidget');
    } else {
        $('.countdown-main').appendTo('.header-top-right');
    }
}


$(document).ready(function () {
    
   
    const windowSize = $(window).width();
    if (windowSize < 1001) {
        $('body')
        .addClass('saffireMobileSize')
        .removeClass('saffireLargeSize');
    } if (windowSize > 1000) {
        $('body').removeClass('saffireMobileSize');
    }
    $('.generalmessage').prependTo('header');
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
    $(".email-main .emailSubmitButton").html("join");
    countdown();
});

$(window).load(function () {
 
    $(".footerItems1 a").removeClass("button");
    // Weather Bug
    setInterval(function () {
        var str = $('#weatherBugDescription').text();
        var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
        if (!weatherBugSet && str != '') {
            $('#weatherBugWidget').addClass('weatherBugSet');
            var findSpace = str.lastIndexOf(' ');
            var stringLength = str.length;
            var res = str.substring(findSpace, stringLength);
            var start = str.substring(0, findSpace);
            $('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
            $('#weatherBugWidget').css('visibility', 'visible');
        }
    }, 12); $(".arrow-down").on('click', function () {
        $('html, body').animate({
            'scrollTop': $(".outer-medium").position().top
        });
    });
});
$(window).resize(function () {
    countdown();
});